// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* VIP Banner Styles */
.vip-banner {
    margin: 0 0 24px;
    background: linear-gradient(135deg, #333333 0%, #000000 100%);
    border-radius: 16px;
    padding: 18px 20px;
    cursor: pointer;
    box-shadow: 0 8px 20px rgba(0,0,0,0.15);
    position: relative;
    overflow: hidden;
    transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.vip-banner:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 24px rgba(0,0,0,0.2);
}

.vip-banner::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -20%;
    width: 200px;
    height: 200px;
    background: radial-gradient(circle, rgba(255,215,0,0.15) 0%, rgba(255,255,255,0) 70%);
    border-radius: 50%;
}

.vip-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 1;
}

.vip-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.vip-icon {
    font-size: 28px;
    filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3));
}

.vip-title {
    margin: 0 0 4px;
    color: #FFD700; /* Gold */
    font-size: 1.1rem;
    font-weight: 700;
    letter-spacing: 0.5px;
}

.vip-desc {
    margin: 0;
    color: rgba(255,255,255,0.8);
    font-size: 0.8rem;
}

.vip-action {
    display: flex;
    align-items: center;
    background: rgba(255,215,0,0.15);
    padding: 6px 12px;
    border-radius: 20px;
    border: 1px solid rgba(255,215,0,0.3);
}

.vip-action span:first-child {
    font-size: 0.85rem;
    color: #FFD700;
    font-weight: 600;
}

.vip-arrow {
    color: #FFD700;
    margin-left: 4px;
    font-size: 1rem;
    transition: transform 0.2s;
}

.vip-banner:hover .vip-arrow {
    transform: translateX(4px);
}

/* =========================================
   Membership Order Card Styles (New)
   ========================================= */

.membership-card {
    background: linear-gradient(135deg, #fff 0%, #fffbf0 100%) !important;
    border: 1px solid rgba(212, 175, 55, 0.2) !important;
    box-shadow: 0 4px 12px rgba(212, 175, 55, 0.08) !important;
    position: relative;
    overflow: hidden;
}

.membership-card::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 60px;
    height: 60px;
    background: linear-gradient(135deg, transparent 50%, rgba(212, 175, 55, 0.1) 50%);
    z-index: 0;
}

.membership-card h4 {
    color: #8c6b1d !important; /* Gold text for title */
    display: flex;
    align-items: center;
    gap: 8px;
}

.tag-vip-badge {
    font-size: 10px;
    background: #333;
    color: #FFD700;
    padding: 1px 6px;
    border-radius: 4px;
    font-weight: normal;
    display: inline-block;
    vertical-align: middle;
}

.order-rights-summary {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.right-tag {
    font-size: 12px;
    color: #5d4037;
    background: rgba(212, 175, 55, 0.1);
    padding: 3px 8px;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    border: 1px solid rgba(212, 175, 55, 0.15);
}

.right-tag .dot {
    width: 4px;
    height: 4px;
    background: #d4af37;
    border-radius: 50%;
    margin-right: 6px;
}

.status-vip-active {
    background-color: #f0f4c3 !important;
    color: #827717 !important;
    border: 1px solid #e6ee9c;
}

/* Redeeming Button Styles */
.btn-vip-redeem {
    background: linear-gradient(135deg, #2b2b2b 0%, #000000 100%) !important;
    color: #e6c575 !important; /* Soft Gold */
    border: 1px solid #4a4a4a !important;
    padding: 8px 16px !important;
    border-radius: 20px !important;
    font-weight: 500 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.15);
    transition: all 0.3s ease;
    min-width: 90px;
}

.btn-vip-redeem:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(0,0,0,0.25);
    border-color: #e6c575 !important;
    color: #fff !important;
}

.btn-vip-redeem .arrow {
    font-size: 14px;
    transition: transform 0.3s ease;
}

.btn-vip-redeem:hover .arrow {
    transform: translateX(3px);
}`, "",{"version":3,"sources":["webpack://./src/components/MyPageExtend.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,gBAAgB;IAChB,6DAA6D;IAC7D,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,uCAAuC;IACvC,kBAAkB;IAClB,gBAAgB;IAChB,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,qFAAqF;IACrF,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,eAAe;IACf,cAAc,EAAE,SAAS;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,iBAAiB;IACjB,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;8CAE8C;;AAE9C;IACI,qEAAqE;IACrE,oDAAoD;IACpD,0DAA0D;IAC1D,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,iFAAiF;IACjF,UAAU;AACd;;AAEA;IACI,yBAAyB,EAAE,wBAAwB;IACnD,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA,4BAA4B;AAC5B;IACI,wEAAwE;IACxE,yBAAyB,EAAE,cAAc;IACzC,oCAAoC;IACpC,4BAA4B;IAC5B,8BAA8B;IAC9B,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,uCAAuC;IACvC,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;IACvC,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":["/* VIP Banner Styles */\r\n.vip-banner {\r\n    margin: 0 0 24px;\r\n    background: linear-gradient(135deg, #333333 0%, #000000 100%);\r\n    border-radius: 16px;\r\n    padding: 18px 20px;\r\n    cursor: pointer;\r\n    box-shadow: 0 8px 20px rgba(0,0,0,0.15);\r\n    position: relative;\r\n    overflow: hidden;\r\n    transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.vip-banner:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 12px 24px rgba(0,0,0,0.2);\r\n}\r\n\r\n.vip-banner::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: -50%;\r\n    right: -20%;\r\n    width: 200px;\r\n    height: 200px;\r\n    background: radial-gradient(circle, rgba(255,215,0,0.15) 0%, rgba(255,255,255,0) 70%);\r\n    border-radius: 50%;\r\n}\r\n\r\n.vip-content {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n.vip-left {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n}\r\n\r\n.vip-icon {\r\n    font-size: 28px;\r\n    filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3));\r\n}\r\n\r\n.vip-title {\r\n    margin: 0 0 4px;\r\n    color: #FFD700; /* Gold */\r\n    font-size: 1.1rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.5px;\r\n}\r\n\r\n.vip-desc {\r\n    margin: 0;\r\n    color: rgba(255,255,255,0.8);\r\n    font-size: 0.8rem;\r\n}\r\n\r\n.vip-action {\r\n    display: flex;\r\n    align-items: center;\r\n    background: rgba(255,215,0,0.15);\r\n    padding: 6px 12px;\r\n    border-radius: 20px;\r\n    border: 1px solid rgba(255,215,0,0.3);\r\n}\r\n\r\n.vip-action span:first-child {\r\n    font-size: 0.85rem;\r\n    color: #FFD700;\r\n    font-weight: 600;\r\n}\r\n\r\n.vip-arrow {\r\n    color: #FFD700;\r\n    margin-left: 4px;\r\n    font-size: 1rem;\r\n    transition: transform 0.2s;\r\n}\r\n\r\n.vip-banner:hover .vip-arrow {\r\n    transform: translateX(4px);\r\n}\r\n\r\n/* =========================================\r\n   Membership Order Card Styles (New)\r\n   ========================================= */\r\n\r\n.membership-card {\r\n    background: linear-gradient(135deg, #fff 0%, #fffbf0 100%) !important;\r\n    border: 1px solid rgba(212, 175, 55, 0.2) !important;\r\n    box-shadow: 0 4px 12px rgba(212, 175, 55, 0.08) !important;\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.membership-card::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    width: 60px;\r\n    height: 60px;\r\n    background: linear-gradient(135deg, transparent 50%, rgba(212, 175, 55, 0.1) 50%);\r\n    z-index: 0;\r\n}\r\n\r\n.membership-card h4 {\r\n    color: #8c6b1d !important; /* Gold text for title */\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.tag-vip-badge {\r\n    font-size: 10px;\r\n    background: #333;\r\n    color: #FFD700;\r\n    padding: 1px 6px;\r\n    border-radius: 4px;\r\n    font-weight: normal;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n}\r\n\r\n.order-rights-summary {\r\n    margin-top: 10px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 6px;\r\n}\r\n\r\n.right-tag {\r\n    font-size: 12px;\r\n    color: #5d4037;\r\n    background: rgba(212, 175, 55, 0.1);\r\n    padding: 3px 8px;\r\n    border-radius: 6px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    border: 1px solid rgba(212, 175, 55, 0.15);\r\n}\r\n\r\n.right-tag .dot {\r\n    width: 4px;\r\n    height: 4px;\r\n    background: #d4af37;\r\n    border-radius: 50%;\r\n    margin-right: 6px;\r\n}\r\n\r\n.status-vip-active {\r\n    background-color: #f0f4c3 !important;\r\n    color: #827717 !important;\r\n    border: 1px solid #e6ee9c;\r\n}\r\n\r\n/* Redeeming Button Styles */\r\n.btn-vip-redeem {\r\n    background: linear-gradient(135deg, #2b2b2b 0%, #000000 100%) !important;\r\n    color: #e6c575 !important; /* Soft Gold */\r\n    border: 1px solid #4a4a4a !important;\r\n    padding: 8px 16px !important;\r\n    border-radius: 20px !important;\r\n    font-weight: 500 !important;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 6px;\r\n    box-shadow: 0 4px 10px rgba(0,0,0,0.15);\r\n    transition: all 0.3s ease;\r\n    min-width: 90px;\r\n}\r\n\r\n.btn-vip-redeem:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 6px 14px rgba(0,0,0,0.25);\r\n    border-color: #e6c575 !important;\r\n    color: #fff !important;\r\n}\r\n\r\n.btn-vip-redeem .arrow {\r\n    font-size: 14px;\r\n    transition: transform 0.3s ease;\r\n}\r\n\r\n.btn-vip-redeem:hover .arrow {\r\n    transform: translateX(3px);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
